var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column-container grow",staticStyle:{"background-color":"yellow"}},[_c('sidebar'),_c('navbar'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }